import { useState } from 'react'
import { CalendarBlank } from '@phosphor-icons/react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Filter from '../../Filter/Filter'

import Box from './Box'
import Overview from './Overview'
import RecentReviews from './RecentReviews'
import SelectLocationReminder from './SelectLocationReminder'
import { getPeriodOptions } from './helpers'

const DashboardTab = ({ goToReviews = () => {}, showModal = () => {}, buildingId }) => {
  const { t } = useTranslation(['organisation'])
  const periodOptions = getPeriodOptions(t)
  const [period, setPeriod] = useState(periodOptions[0])

  return (
    <div className="reputation-dashboard-tab">
      <SelectLocationReminder onClick={showModal} />
      <Box
        title={t('organisation:reputationManagement.dashboardTab.overviewTitle')}
        headerActions={
          <Filter
            placeholder={
              <div className="reputation-dashboard-tab__filter-placeholder">
                <CalendarBlank size={20} />
                {period.text}
              </div>
            }
            options={periodOptions}
            value={[period]}
            name={'period'}
            additionalClass={'reputation-dashboard-tab__filter'}
            onChange={(e) => setPeriod(e.target.value)}
            closeAfterSelect
          />
        }
        content={<Overview period={period} buildingId={buildingId} />}
      />
      <RecentReviews goToReviews={goToReviews} period={period} buildingId={buildingId} />
    </div>
  )
}

DashboardTab.propTypes = {
  goToReviews: PropTypes.func,
  showModal: PropTypes.func,
  buildingId: PropTypes.number,
}

export default DashboardTab
